import * as React from "react";
import { ConfigProvider, Input } from "antd";
import "@ant-design/pro-table/dist/table.css";
import ProTable, { ProColumns } from "@ant-design/pro-table";
import { ColumnsStateType } from "@ant-design/pro-table/lib/typing";
import enUS from "antd/lib/locale/en_US";
import DateRangePicker from "../../pages/analytics/DateRangePicker";

interface TableProps {
  columns: ProColumns[];
  columnsState?: ColumnsStateType;
  className?: string;
}
const AntdTablePro = React.memo(
  ({
    columns,
    request,
    columnsState,
    inputElement,
    dateRangeElement,
    toolBarRender = [],
    rowClassName,
    className,
    onDoubleClick,
    ...rest
  }: TableProps & any) => {
    const [activeRow, setActiveRow] = React.useState<string | null>(null);

    const handleRowClick = (record: any) => {
      setActiveRow((prev) => (prev === record.id ? null : record.id));
    };

    const getRowClassName = (record: any) => {
      const baseClassName = rowClassName
        ? typeof rowClassName === "function"
          ? rowClassName(record)
          : rowClassName
        : "";

      return record.id === activeRow
        ? `${baseClassName} row-active`
        : baseClassName;
    };
    return (
      <ConfigProvider locale={enUS}>
        <ProTable
          className={`App ${className ? className : ""}`}
          size="small"
          columns={columns}
          request={request}
          rowClassName={getRowClassName}
          onRow={(dataSource) => ({
            onClick: () => handleRowClick(dataSource),
            onDoubleClick: () => onDoubleClick?.(dataSource),
          })}
          toolBarRender={
            toolBarRender
              ? () => [
                  <div
                    key="toolbar-filters-container"
                    className="toolbar-filters-container"
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                    }}
                  >
                    <Input.Search
                      className="toolbar-search-input"
                      style={{
                        width: "100%",
                      }}
                      enterButton
                      allowClear
                      onSearch={(value) => inputElement?.handleSearch(value)}
                      onChange={(value) => inputElement?.handleChange(value)}
                      placeholder={inputElement.placeholder}
                    />
                    {dateRangeElement && (
                      <div
                        className="date-range-filters"
                        style={{
                          display: "flex",
                          gap: "12px",
                        }}
                      >
                        {Array.isArray(dateRangeElement)
                          ? dateRangeElement.map((element, index) => (
                              <DateRangePicker
                                key={`date-range-picker-${index}`}
                                startDate={element.startDate}
                                endDate={element.endDate}
                                onRangeChange={element.onRangeChange}
                                placeholder={element.placeholder}
                                style={{ width: "auto" }}
                              />
                            ))
                          : [
                              <DateRangePicker
                                key="date-range-picker"
                                startDate={dateRangeElement.startDate}
                                endDate={dateRangeElement.endDate}
                                onRangeChange={dateRangeElement.onRangeChange}
                                placeholder={dateRangeElement.placeholder}
                                style={{ width: "auto" }}
                              />,
                            ]}
                      </div>
                    )}
                  </div>,
                  ...toolBarRender,
                ]
              : false
          }
          search={false}
          columnsState={columnsState}
          {...rest}
        />
      </ConfigProvider>
    );
  }
);

export default AntdTablePro;
